'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var preventEventPropagation = function preventEventPropagation(event) {
  // This is needed to prevent Safari focusing the element on click.
  event.preventDefault();
  event.stopPropagation();
};

exports.preventEventPropagation = preventEventPropagation;
//# sourceMappingURL=index.js.map
